import { useMemo } from 'react';
import { getLocale } from 'umi';
import { LANGUAGE_CN } from '@/pages/intelligence/_config/config';

/**
 * 获取 当前语言环境特有的className，用于 针对不同语言环境 需要做 特殊样式处理的场景
 * lang-en: 英文环境的className
 * lang-cn：中文环境的className
 * @returns 当前语言环境特有的className
 */
export default function useLocaleClassName() {
  const locale = getLocale();
  const className = useMemo(() => (locale === LANGUAGE_CN ? 'lang-cn' : 'lang-en'), [locale]);

  return className;
}
